import React from 'react';
import DeliveryFeeDescription from '../DeliveryFeeDescription/DeliveryFeeDescription';
import _get from 'lodash/get';
interface MenuDeliveryDescriptionProps {
  deliveryContentBlock: {
    deliveryFeeDescription: string;
    howFeeWork: string;
    feeWorkOverlay: string;
    informationIcon: string;
  };
  orderViewModel: any;
}
const MenuDeliveryDescription: React.FC<MenuDeliveryDescriptionProps> = ({
  deliveryContentBlock,
  orderViewModel,
}) => {
  return (
    <DeliveryFeeDescription
      deliveryFeeDescription={_get(deliveryContentBlock, ['deliveryFeeDescription'], '')}
      howFeeWork={_get(deliveryContentBlock, ['howFeeWork'], '')}
      feeWorkOverlay={_get(deliveryContentBlock, ['feeWorkOverlay'], '')}
      orderViewModel={orderViewModel}
      informationIcon={_get(deliveryContentBlock, ['informationIcon'], '')}
    />
  );
};

export default MenuDeliveryDescription;
